'use client';

import * as React from 'react';
import Box from '@mui/material/Box';
import { useColorScheme } from '@mui/material/styles';

import { NoSsr } from '@src/components/core/no-ssr';
import logo from '@src/assets/logo-full-dark.png';
import logoDark from '@src/assets/logo-full.png';

// Set sensible defaults (can still override)
const DEFAULT_HEIGHT = '40px';
const DEFAULT_WIDTH = 'auto'; // Let it scale naturally

export function Logo({ color = 'dark', emblem, height = DEFAULT_HEIGHT, width = DEFAULT_WIDTH, src, alt = 'logo' }) {
  const resolvedSrc = src || (emblem
    ? color === 'light' ? logo : logoDark
    : color === 'light' ? logo : logoDark);

  return <Box alt={alt} component="img" height={height} src={resolvedSrc} width={width} />;
}

export function DynamicLogo({
  colorDark = 'light',
  colorLight = 'dark',
  height = DEFAULT_HEIGHT,
  width = DEFAULT_WIDTH,
  ...props
}) {
  const { colorScheme } = useColorScheme();
  const color = colorScheme === 'dark' ? colorDark : colorLight;

  return (
    <NoSsr fallback={<Box sx={{ height, width }} />}>
      <Logo color={color} height={height} width={width} {...props} />
    </NoSsr>
  );
}
